import React from 'react';

import {
    Box,
    Grid,
    Accordion,
    Typography,
    AccordionDetails,
    AccordionSummary,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import ShadowDomEmail from 'components/Inventory/utils/ShadowDomEmail';
import { extractPlainText } from 'components/Inventory/utils/emailUtils';
import { emailDetailsAccordionStyles } from 'components/Inventory/style/style';

const EmailDetailsAccordion = ({ email }) => {
    const classes = emailDetailsAccordionStyles();

    return (
        <Box sx={classes.accordionWrapper}>
            <Accordion key={email?.id} sx={classes.accordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={classes.summary}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={3}>
                            <Typography variant="body1" fontWeight="bold">
                                Sender:
                            </Typography>
                            <Typography variant="body2" sx={classes.addToNewLine}>
                                {email?.sender}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body1" fontWeight="bold">
                                Subject:
                            </Typography>
                            <Typography variant="body2">{email?.subject}</Typography>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Typography variant="body1" fontWeight="bold">
                                Received At:
                            </Typography>
                            <Typography variant="body2">{email?.timeReceived}</Typography>
                        </Grid>
                    </Grid>
                </AccordionSummary>

                <AccordionDetails sx={classes.accordionDetails}>
                    {email?.stripped_html ? (
                        <ShadowDomEmail html={email.stripped_html} />
                    ) : (
                        <Typography variant="body2" sx={classes.noBodyText}>
                            {extractPlainText(email?.body)}
                        </Typography>
                    )}
                </AccordionDetails>
            </Accordion>
        </Box>
    );
};

export default EmailDetailsAccordion;
